export const chartColors = [
  "rgb(14, 220, 232)",   // Cyan
  "rgb(16, 150, 24)",    // Green
  "rgb(255, 153, 0)",    // Orange
  "rgb(153, 0, 153)",    // Purple
  "rgb(0, 153, 198)",    // Teal
  "rgb(51, 102, 204)",   // Blue
  "rgb(220, 57, 18)",    // Red-Orange
  "rgb(102, 170, 0)",    // Olive Green
  "rgb(221, 68, 119)",   // Pink
  "rgb(237, 237, 1)",    // Yellow
  "rgb(0, 76, 153)",     // Dark Blue
  "rgb(255, 0, 0)",      // Red
  "rgb(128, 0, 128)",    // Dark Purple
  "rgb(0, 128, 128)",    // Dark Teal
  "rgb(255, 99, 71)",    // Tomato
  "rgb(75, 0, 130)",     // Indigo
  "rgb(255, 165, 0)",    // Golden Orange
  "rgb(0, 100, 0)",      // Dark Green
  "rgb(70, 130, 180)",   // Steel Blue
  "rgb(178, 34, 34)",    // Firebrick Red
];
